import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            marginBottom: 0
        },
        [theme.breakpoints.up('md')]: {
            marginBottom: '40px'
        },
    },
    title: {
        font: 'normal normal bold 60px/114px brandon-grotesque',
        color: '#00838F'
    },
    paragraph: {
        font: 'normal normal 500 28px/45px brandon-grotesque',
        letterSpacing: 0,
        margin: '40px 34%',
        color: theme.palette.text.primary,
        [theme.breakpoints.down('sm')]: {
            margin: '10px',
            font: 'normal normal 500 20px/29px brandon-grotesque'
        },
        [theme.breakpoints.up('sm')]: {
            margin: '20px 5%',
            font: 'normal normal 500 28px/45px brandon-grotesque'
        },
        [theme.breakpoints.up('md')]: {
            margin: '40px 34%',
            font: 'normal normal 500 28px/45px brandon-grotesque',
        }
    },
    fourSquares: {
        padding: '20px 22%',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: '#ffffff',
            padding: '0 10px'
        },
        [theme.breakpoints.up('sm')]: {
            backgroundColor: '#ffffff',
            padding: '10px 20px'
        },
        [theme.breakpoints.up('md')]: {
            backgroundColor: '#ffffff',
            padding: '20px 22%',
        }
    },
    fourSquaresItem: {
        padding: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            padding: '0 !important'
        },
        [theme.breakpoints.up('sm')]: {
            padding: '10px !important'
        },
        [theme.breakpoints.up('md')]: {
            padding: '0 !important',
            maxHeight: '250px',
        }
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.text.secondary,
        borderRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            minHeight:  '100px',
        },
        [theme.breakpoints.up('sm')]: {
            minHeight:  '200px',
        },
        [theme.breakpoints.up('md')]: {
            minHeight:  '400px'
        }
    },
    boxTitle:{
        padding: '0 25px',
        font: 'normal normal 900 28px/40px brandon-grotesque',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: theme.spacing(1),
            font: 'normal normal 900 23px/35px brandon-grotesque',
        },
        [theme.breakpoints.up('sm')]: {
            font: 'normal normal 900 28px/40px brandon-grotesque',
            marginTop: '10px'
        },
        [theme.breakpoints.up('md')]: {
            font: 'normal normal 900 28px/40px brandon-grotesque',
            marginTop: '10px'
        }
    },
    boxSubTitle: {
        font: 'normal normal bold 25px/32px brandon-grotesque',
        marginTop: '-10px',
        [theme.breakpoints.down('sm')]: {
            marginTop: '-5px',
            font: 'normal normal bold 16px/18px brandon-grotesque',
        },
        [theme.breakpoints.up('sm')]: {
            font: 'normal normal bold 18px/32px brandon-grotesque',
        },
        [theme.breakpoints.up('md')]: {
            font: 'normal normal bold 18px/32px brandon-grotesque',
        }
    },
    boxDescription: {
        font: 'normal normal 400 35px/50px brandon-grotesque'
    },
    greenIcon: {
        fill: '#00838F'
    },
    iconTenSeconds: {
        minHeight: '125px',
        [theme.breakpoints.down('sm')]: {
            minHeight: 0,
            height: '100px'
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 0,
            height: '100px'
        },
        [theme.breakpoints.up('md')]: {
            minHeight: 0,
            height: '125px'
        }
    },
    iconPointer: {
        minHeight: '125px',
        [theme.breakpoints.down('sm')]: {
            minHeight: 0,
            height: '125px'
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 0,
            height: '125px'
        },
        [theme.breakpoints.up('md')]: {
            minHeight: 0,
            height: '125px'
        }
    },
    iconCalendar: {
        minHeight: '125px',
        [theme.breakpoints.down('sm')]: {
            minHeight: 0,
            height: '110px'
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 0,
            height: '110px'
        },
        [theme.breakpoints.up('md')]: {
            minHeight: 0,
            height: '125px'
        }
    },
    svgTenSeconds: {
        [theme.breakpoints.down('sm')]: {
            width: '70px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '100px'
        },
        [theme.breakpoints.up('md')]: {
            width: '100px'
        }
    },
    svgPointer: {
        [theme.breakpoints.down('sm')]: {
            width: '70px'
        },
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
            height: '120px'
        },
        [theme.breakpoints.up('md')]: {
            width: 'auto',
            height: '120px'
        }
    },
    svgCalendar: {
        [theme.breakpoints.down('sm')]: {
            width: '65px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '90px'
        },
        [theme.breakpoints.up('md')]: {
            width: '90px'
        }
    }
}));

const TenSeconds = (props) => (
    <svg className={props.svgImage} xmlns="http://www.w3.org/2000/svg" width="150.853" height="132.303" viewBox="0 0 150.853 132.303" aria-labelledby="tenSecondsTitle tenSecondsDesc" role="img">
        <title id="tenSecondsTitle">10-second approvals</title>
        <desc id="tenSecondsDesc">10-second approvals</desc>
        <g transform="translate(0 0)"><path className={props.fill} d="M40.753,20.937a1.677,1.677,0,1,0-3.353,0V48.159a1.677,1.677,0,0,0,1.677,1.677h35.7a1.677,1.677,0,1,0,0-3.353H40.753Z" transform="translate(36.376 18.734)"/><path className={props.fill} d="M62.342,9.14a48.8,48.8,0,1,0,48.782,48.8A48.8,48.8,0,0,0,62.342,9.14Zm0,94.251a45.37,45.37,0,1,1,45.37-45.37,45.37,45.37,0,0,1-45.37,45.37Z" transform="translate(13.151 8.891)"/><path className={props.fill} d="M100.463,92.417a1.677,1.677,0,0,0-2.209-.828l-4.912,2.229A73.341,73.341,0,0,0,53.949.139a1.657,1.657,0,0,0-2.19.868,1.677,1.677,0,0,0,.868,2.209A69.909,69.909,0,0,1,89.85,93.561l-2.722-5.918a1.637,1.637,0,0,0-2.229-.848,1.657,1.657,0,0,0-.828,2.229l4.083,9.015a1.775,1.775,0,0,0,.947.868,1.519,1.519,0,0,0,.592.118,1.677,1.677,0,0,0,.69-.158l9.33-4.182a1.677,1.677,0,0,0,.75-2.268Z" transform="translate(50.205 0.001)"/><path className={props.fill} d="M47.994,112.634A70.047,70.047,0,0,1,5.761,46.769a69.139,69.139,0,0,1,5.05-24.48l2.7,5.918a1.637,1.637,0,0,0,2.268.868,1.7,1.7,0,0,0,.789-2.15l-4.1-9.094a1.637,1.637,0,0,0-.947-.769,1.7,1.7,0,0,0-1.282,0L.987,21.2a1.677,1.677,0,1,0,1.381,3.058l4.912-2.229a73.341,73.341,0,0,0,39.393,93.659,1.539,1.539,0,0,0,.651.138,1.677,1.677,0,0,0,.671-3.215Z" transform="translate(0.001 16.473)"/></g>
    </svg>
);

const Pointer = (props) => (
    <svg className={props.svgImage}  xmlns="http://www.w3.org/2000/svg" width="118.326" height="149.326" viewBox="0 0 118.326 149.326" aria-labelledby="pointerTitle pointerDesc" role="img">
        <title id="pointerTitle">Highly competitive interest rates</title>
        <desc id="pointerDesc">Highty competitive interest rates</desc>
        <g transform="translate(0 0)"><path className={props.fill} d="M81.219,74.924l-30.2-13.2V31.409a10.139,10.139,0,0,0-20.259,0L30.306,82.7C21.035,75.2,13.44,71.807,7.68,72.616a7.673,7.673,0,0,0-5.444,2.919,1.7,1.7,0,0,0,0,1.973l26.906,36.414,5.444,13.236a1.677,1.677,0,0,0,1.539,1.045H75.893a1.677,1.677,0,0,0,1.677-1.519l4.655-50.064a1.7,1.7,0,0,0-1.006-1.7Zm-6.845,49.926H37.249L32.16,112.463a1.361,1.361,0,0,0-.2-.375L5.885,76.7a5.484,5.484,0,0,1,2.249-.769c2.979-.414,9.863.552,22.7,11.6a1.657,1.657,0,0,0,1.8.256,1.637,1.637,0,0,0,.986-1.5l.493-54.878a6.786,6.786,0,0,1,13.552,0V62.793a1.677,1.677,0,0,0,1.006,1.539l30.1,13.177Z" transform="translate(1.881 21.122)"/><path className={props.fill} d="M42.122,0A42.115,42.115,0,0,0,12.336,71.9,1.677,1.677,0,0,0,14.7,69.534a38.779,38.779,0,1,1,54.838,0A1.674,1.674,0,1,0,71.908,71.9,42.115,42.115,0,0,0,42.122,0Z" transform="translate(0.007 0)"/><path className={props.fill} d="M18.047,18.048A15.307,15.307,0,0,0,13.53,28.957a1.677,1.677,0,0,0,3.353,0,12.072,12.072,0,0,1,24.145,0,1.677,1.677,0,1,0,3.353,0A15.426,15.426,0,0,0,18.047,18.048Z" transform="translate(13.173 13.158)"/><path className={props.fill} d="M53.344,55.725a1.7,1.7,0,0,0,2.387,0,28.642,28.642,0,1,0-40.517,0,1.7,1.7,0,0,0,2.387,0,1.657,1.657,0,0,0,0-2.367,25.289,25.289,0,1,1,35.783,0,1.657,1.657,0,0,0-.039,2.367Z" transform="translate(6.657 6.648)"/><path className={props.fill} d="M70.623,51.135C69.065,46.3,64.607,45.573,61,44.981a10.376,10.376,0,0,1-6.214-2.328,3.768,3.768,0,0,1-.967-2.919,3.945,3.945,0,0,1,1.4-2.7,8.028,8.028,0,0,1,6.233-1.184A9.192,9.192,0,0,1,66.4,38.234a1.657,1.657,0,0,0,2.367,0,1.677,1.677,0,0,0,0-2.367A12.526,12.526,0,0,0,62,32.474H61.47V28a1.677,1.677,0,1,0-3.353,0v4.419a10.258,10.258,0,0,0-5.05,1.973,7.239,7.239,0,0,0-.907,10.474c2.13,2.407,5.346,2.939,8.186,3.413,3.748.612,6.1,1.124,6.983,3.945a4.636,4.636,0,0,1-.572,3.945A6.786,6.786,0,0,1,62.1,59.124a13.2,13.2,0,0,1-10.534-3.1,1.7,1.7,0,0,0-2.387,0,1.677,1.677,0,0,0,0,2.367,15.939,15.939,0,0,0,8.857,3.945V66.8a1.677,1.677,0,0,0,3.353,0v-4.34h1.045a10.1,10.1,0,0,0,7.062-4.5,7.89,7.89,0,0,0,1.124-6.825Z" transform="translate(47.372 25.599)"/></g>
    </svg>
);

const Calendar = (props) => (
    <svg className={props.svgImage}  xmlns="http://www.w3.org/2000/svg" width="111.271" height="123.288" viewBox="0 0 111.271 123.288" aria-labelledby="calendarTitle calendarDesc" role="img">
        <title id="calendarTitle">Next day funding</title>
        <desc id="calendarDesc">Next day funding</desc>
        <g transform="translate(0 0)"><path className={props.fill} d="M90.556,7.17H85.307V1.606a1.576,1.576,0,0,0-3.153,0V7.17H66.577V1.606a1.576,1.576,0,1,0-3.153,0V7.17H47.846V1.606a1.576,1.576,0,0,0-3.153,0V7.17H29.023V1.606a1.576,1.576,0,0,0-3.153,0V7.17H20.678A20.7,20.7,0,0,0,0,27.792V102.64a20.7,20.7,0,0,0,20.678,20.678H90.556a20.7,20.7,0,0,0,20.715-20.678V27.792A20.7,20.7,0,0,0,90.556,7.17ZM20.678,10.323h5.285V12.01a1.576,1.576,0,1,0,3.153,0V10.323h15.6V12.01a1.576,1.576,0,1,0,3.153,0V10.323H63.443V12.01a1.576,1.576,0,1,0,3.153,0V10.323H82.173V12.01a1.576,1.576,0,0,0,3.153,0V10.323h5.322a17.544,17.544,0,0,1,17.432,17.469V49.824H3.153V27.792A17.544,17.544,0,0,1,20.678,10.323ZM90.556,120.165H20.678A17.544,17.544,0,0,1,3.153,102.64V52.976H108.081V102.64a17.544,17.544,0,0,1-17.525,17.525Z" transform="translate(0 -0.03)"/><path className={props.fill} d="M15.166,19.263H72.842a1.576,1.576,0,0,0,0-3.153H15.166a1.576,1.576,0,1,0,0,3.153Z" transform="translate(11.613 13.711)"/><path className={props.fill} d="M26.246,44.81H12.726a1.576,1.576,0,1,0,0,3.153H26.32a1.576,1.576,0,1,0,0-3.153Z" transform="translate(9.528 38.235)"/><path className={props.fill} d="M40.478,44.81H26.866a1.576,1.576,0,1,0,0,3.153H40.478a1.576,1.576,0,0,0,0-3.153Z" transform="translate(21.611 38.235)"/><path className={props.fill} d="M55.18,44.81H41.586a1.576,1.576,0,1,0,0,3.153H55.18a1.576,1.576,0,0,0,0-3.153Z" transform="translate(34.189 38.235)"/><path className={props.fill} d="M26.246,36H12.726a1.576,1.576,0,1,0,0,3.153H26.32a1.576,1.576,0,1,0,0-3.153Z" transform="translate(9.528 30.707)"/><path className={props.fill} d="M40.478,36H26.866a1.576,1.576,0,1,0,0,3.153H40.478a1.576,1.576,0,0,0,0-3.153Z" transform="translate(21.611 30.707)"/><path className={props.fill} d="M55.18,36H41.586a1.576,1.576,0,1,0,0,3.153H55.18a1.576,1.576,0,0,0,0-3.153Z" transform="translate(34.189 30.707)"/><path className={props.fill} d="M26.246,53.58H12.726a1.576,1.576,0,1,0,0,3.153H26.32a1.576,1.576,0,0,0,0-3.153Z" transform="translate(9.528 45.729)"/><path className={props.fill} d="M40.478,53.58H26.866a1.576,1.576,0,1,0,0,3.153H40.478a1.576,1.576,0,0,0,0-3.153Z" transform="translate(21.611 45.729)"/><path className={props.fill} d="M55.18,53.58H41.586a1.576,1.576,0,0,0,0,3.153H55.18a1.576,1.576,0,0,0,0-3.153Z" transform="translate(34.189 45.729)"/></g>
    </svg>
);

const SectionTwo = () => {
    const classes = useStyles();
    return (
        <section>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Box className={classes.paragraph}>
                    Want to dramatically increase your business quickly? Join Direct Pay, and get access to Loanpal’s industry-leading financing programs featuring:
                    </Box>
                </Grid>
            </Grid>
            <div className={classes.root}>
                <Grid container className={classes.fourSquares}>
                    <Grid item xs={12} sm={12} md={4} className={classes.fourSquaresItem}>
                        <Paper elevation={0} className={classes.paper}>
                            <Box className={classes.iconTenSeconds}>
                                <TenSeconds fill={classes.greenIcon} svgImage={classes.svgTenSeconds}/>
                            </Box>
                            <Box m={2} className={classes.boxTitle}>10-second approvals</Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className={classes.fourSquaresItem}>
                        <Paper elevation={0} className={classes.paper}>
                            <Box className={classes.iconPointer}>
                                <Pointer fill={classes.greenIcon} svgImage={classes.svgPointer} />
                            </Box>
                            <Box m={2} className={classes.boxTitle}>highly competitive interest rates</Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className={classes.fourSquaresItem}>
                        <Paper elevation={0} className={classes.paper}>
                            <Box className={classes.iconCalendar}>
                                <Calendar fill={classes.greenIcon} svgImage={classes.svgCalendar} />
                            </Box>
                            <Box m={2} className={classes.boxTitle}>next day funding</Box>
                            <Box m={2} className={classes.boxSubTitle}><sup>*</sup>after any applicable recission periods</Box>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
            <div className="clearfix" />
        </section>
    );
}

export default SectionTwo;
